import type { EntryWithVisitApproval } from 'garaje/models/entry';
import type { InviteWithVisitApproval } from 'garaje/models/invite';
import Invite from 'garaje/models/invite';

export function approvalMessage(model: InviteWithVisitApproval | EntryWithVisitApproval): string | undefined {
  if (model instanceof Invite && model.needsPropertyApprovalReview)
    return 'Additional approval from the property manager is required before the invitation is sent.';

  if (model.needsApprovalReview && !model.visitApproval.reviewableScreenerSources.length) {
    return 'Submitted. Awaiting additional review by another approver.';
  } else if (model.needsApprovalReview && model.visitApproval.reviewableScreenerSources.length) {
    return 'All other approvals must be completed to approve access.';
  }

  return;
}
